import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISelfEvaluationResource } from "../types/ISelfEvaluationResource";

export interface ISelfEvaluationUpdateMutationParameters {
    selfEvaluation: RelationalValue<ISelfEvaluationResource>;
    title?: string;
    periodStart?: string;
    periodEnd?: string;
    achievements?: string;
    challenges?: string;
    description?: string;
    skillLevels?: string[];
    skills?: string[];
}

export type ISelfEvaluationUpdateMutationResult = ISelfEvaluationResource;

export const selfEvaluationUpdateMutation: IApiMutationFunction<ISelfEvaluationUpdateMutationParameters> = ({
    selfEvaluation,
    ...data
}) => ({
    method: "PUT",
    url: `/self_evaluations/${mapRelationalValue(selfEvaluation)}`,
    data,
});

export const useSelfEvaluationUpdateMutation = createApiMutationHook<
    ISelfEvaluationUpdateMutationParameters,
    ISelfEvaluationUpdateMutationResult
>(selfEvaluationUpdateMutation);
